module.exports = {
  __init__: [ 'interactionEvents' ],
  interactionEvents: [ 'type', require(46) ]
};